import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { MdsConfig } from "@maersk-global/mds-config";

MdsConfig.iconsDynamicImportPath = `${location.protocol}//${location.host}/assets/`;
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
